import { useState, useEffect, useCallback } from "react";
import { getElectronicDocumentsPage } from "shared/api/services";
import { PackageInvoicesRow } from "../helper/columnsPackageInvoices";
import { mapElectronicDocumentsToPackageInvoices } from "../helper/mapperPackageInvoices";

export const usePackageInvoices = (electronicDocumentIds?: number[]) => {
  const [packageInvoices, setPackageInvoices] = useState<PackageInvoicesRow[]>(
    [],
  );
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [totalElements, setTotalElements] = useState(0);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(50);

  const fetchPackageInvoices = useCallback(
    async (currentPage?: number, currentSize?: number) => {
      if (!electronicDocumentIds || electronicDocumentIds.length === 0) {
        setPackageInvoices([]);
        setTotalElements(0);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const idsString = electronicDocumentIds.join(",");
        const response = await getElectronicDocumentsPage({
          ids: idsString,
          page: currentPage ?? page,
          size: currentSize ?? size,
        });
        const mappedData = mapElectronicDocumentsToPackageInvoices(
          response.content,
        );
        setPackageInvoices(mappedData);
        setTotalElements(response.totalElements);
      } catch (err) {
        setError("Error al cargar las facturas del paquete");
        console.error("Error fetching package invoices:", err);
      } finally {
        setIsLoading(false);
      }
    },
    [electronicDocumentIds, page, size],
  );

  useEffect(() => {
    fetchPackageInvoices();
  }, [fetchPackageInvoices]);

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
    fetchPackageInvoices(newPage, size);
  };

  const handleChangeSize = (newSize: number) => {
    setSize(newSize);
    setPage(0);
    fetchPackageInvoices(0, newSize);
  };

  return {
    packageInvoices,
    isLoading,
    error,
    totalElements,
    page,
    size,
    handleChangePage,
    handleChangeSize,
    refetch: fetchPackageInvoices,
  };
};
